module.exports = __webpack_public_path__ + "img/20190704163112YY截图20190704013422.83b6c398.png";